module.exports = __webpack_public_path__ + "img/cover.755d6da1.png";